module.exports = "/images/video-camera-w.svg?957c7e9f27dea18af4ec21beea613cbd";